const TITLE = "Login";

const config = {
    rmm: {
        api: "http://139.59.55.196:4000",
        // api: "http://139.59.55.196:4002/api/v2",//stage
        loginTitle: `${TITLE} | RMM App`
    },
    emisafepro: {
        // api: "http://143.244.143.131:4001",// old server
        api: "https://login.emisafepro.com/api/v2", //new server
        loginTitle: `${TITLE} | EMI SAFE PRO`
    },
    local: {
        // api: "http://192.168.1.91:4000",
        // api: "http://localhost:4000/api/v2",
        api: "https://login.safefin.in/api/v2",
        loginTitle: `${TITLE} | LOCAL`
    },
    safefin: {
        api: "https://login.safefin.in/api/v2",
        // api: "http://139.59.75.250:4002/api/v2",//stage
        loginTitle: `${TITLE} | Safe Fin`
    },
    rsecure: {
        api: "http://143.244.128.56:4001",
        loginTitle: `${TITLE} | Restail Secure`
    },
};
const httpConfig = config[process.env.REACT_APP_APP_CONFIG] || config.local;
export {
    httpConfig
};